const f = {
  color: {
    border: {
      default: "#abb9c7ff",
      hover: "#7e8e9eff"
    },
    label: "#556575ff",
    text: "#314351ff",
    icon: "#314351ff",
    background: {
      empty: "#ffffffff",
      filled: "#f9fafaff",
      hoverValue: "#f1f3f5ff",
      hoverFilled: "#ebf5ffff",
      editing: "#ebf5ffff"
    },
    input: {
      placeholder: "#7e8e9eff",
      text: "#314351ff"
    },
    error: {
      border: "#e54a32ff",
      label: "#b83525ff",
      icon: "#e54a32ff"
    }
  }
};
export {
  f as property
};
